export default {
  files: {},
  fileData: {},
  isFileDataLoading: {},
  lastFileDeleted: null,
};
